import { Heading } from "@biom3/react";
import { Box } from "@biom3/react";
import { Divider } from "@biom3/react";
import { RenderOnceInView } from "@ui-kit";
import { GemsLayout } from "../Gems/Layout/Layout";

export const RewardsDailyGems = () => {
  return (
    <Box sx={{ width: "100%", mt: "base.spacing.x6" }}>
      <Divider
        sx={{
          bg: "base.color.translucent.emphasis.100",
          mb: "base.spacing.x4",
        }}
      />
      <Heading
        size="medium"
        weight="bold"
        sx={{
          mb: "base.spacing.x6",
          color: "base.color.text.heading.primary",
        }}
      >
        Daily Gems Claim
      </Heading>
      <RenderOnceInView placeHolderHeight="300px">
        <GemsLayout />
      </RenderOnceInView>
    </Box>
  );
};
